import {useTranslation} from "react-i18next";
import {FollowUpSuggestion} from "../../../types";
import {bffApi} from "../bffApi";
import classes from "./FollowUpSuggestionChips.module.css";

interface Props {
    suggestions: FollowUpSuggestion[];
    onSelect: (question: string) => void;
}

export const FollowUpSuggestionChips: React.FC<Props> = ({
    suggestions,
    onSelect,
}) => {
    const {t} = useTranslation();
    const [trackAnswer] = bffApi.endpoints.trackAnswer.useMutation();

    if (suggestions.length === 0) {
        return null;
    }

    return (
        <div
            className={classes.root}
            role="group"
            aria-label={t("chat.followUpSuggestions.groupLabel", {
                defaultValue: "Suggested follow-up questions",
            })}
            data-name="followup-suggestions"
        >
            {suggestions.map((suggestion, index) => (
                <button
                    key={suggestion.question}
                    type="button"
                    className={classes.chip}
                    data-kind={suggestion.kind}
                    onClick={() => {
                        trackAnswer({
                            action: "followup_clicked",
                            position: index + 1,
                        });
                        onSelect(suggestion.question);
                    }}
                >
                    <span className={classes.question}>
                        {suggestion.question}
                    </span>
                </button>
            ))}
        </div>
    );
};
